import {setInitialState} from '../../../utils/reducerOperations';
export const Default=()=>({
    stopResponseCollectionApi:setInitialState(),
});